import { render, staticRenderFns } from "./OptionEditor.vue?vue&type=template&id=561b71e3&scoped=true&"
import script from "./OptionEditor.vue?vue&type=script&lang=ts&"
export * from "./OptionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./OptionEditor.vue?vue&type=style&index=0&id=561b71e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b71e3",
  null
  
)

export default component.exports